var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7686 23.9893C16.4852 24.0893 16.0186 24.0893 15.7352 23.9893C13.3186 23.1643 7.91858 19.7226 7.91858 13.8893C7.91858 11.3143 9.99358 9.23096 12.5519 9.23096C14.0686 9.23096 15.4102 9.96429 16.2519 11.0976C17.0936 9.96429 18.4436 9.23096 19.9519 9.23096C22.5102 9.23096 24.5852 11.3143 24.5852 13.8893C24.5852 19.7226 19.1852 23.1643 16.7686 23.9893Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.f627595533e0ee17f260b525c3090d6f.svg";
export { ForwardRef as ReactComponent };